import { AttachmentPromiseClient } from '@trustero/trustero-api-web/lib/attachment/attachment_grpc_web_pb'
import { MODEL_TYPE } from '@trustero/trustero-api-web/lib/common/model_pb'
import {
  GetChangeLogEntriesRequest,
  LogEntries,
  SubjectTypeFilter,
} from '@trustero/trustero-api-web/lib/attachment/attachment_pb'
import { StringList } from '@trustero/trustero-api-web/lib/common/collections_pb'
import { useInAudit } from 'src/context/AuditContext'
import {
  GrpcInfiniteResponse,
  NewGrpcInfiniteResponse,
} from '../../components/async/hooks/types'
import { useSwrInfiniteGrpc } from '../../components/async/useSwrInfiniteGrpc'

export const useChangeLogEntries = (
  itemsPerPage: number,
  pageNumber: number,
  subjectModelIds?: string[],
  subjectIds?: string[],
  subjectType?: MODEL_TYPE,
): GrpcInfiniteResponse<LogEntries> => {
  const { auditId } = useInAudit()
  const requestBuilder = () => {
    const request = new GetChangeLogEntriesRequest()
      .setEntriesPerPage(itemsPerPage)
      .setPageNumber(pageNumber)
    if (auditId) {
      request.setAuditId(auditId)
    }
    if (subjectModelIds) {
      request.setSubjectModelIds(new StringList().setItemList(subjectModelIds))
    }
    if (subjectIds) {
      request.setSubjectIds(new StringList().setItemList(subjectIds))
    }
    if (subjectType) {
      request.setSubjectTypeFilter(
        new SubjectTypeFilter().setSubjectType(subjectType),
      )
    }
    return request
  }
  const { response } = useSwrInfiniteGrpc(
    AttachmentPromiseClient.prototype.getChangeLogEntries,
    requestBuilder,
    pageNumber,
  )
  return NewGrpcInfiniteResponse(response)
}
